// Éditeur de DISPONIBILITÉS d'un collaborateur (par jour de semaine). Utilisé dans la
// fiche RD (Admin) et l'Assistant de placement. Sert de rappel visuel — n'impacte
// aucun calcul. value = { note, jours: { "0".."6": { mode, debut, fin } } }.
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { WEEKDAYS_FR } from "@/lib/dispo";
import { Sun, Clock, Ban } from "lucide-react";

const MODES = [
  { v: "journee", label: "Journée", icon: Sun },
  { v: "creneau", label: "Créneau", icon: Clock },
  { v: "indispo", label: "Indispo", icon: Ban },
];

export const DispoEditor = ({ value, onChange, compact = false }) => {
  const jours = (value && value.jours) || {};
  const note = (value && value.note) || "";

  const setDay = (wd, entry) => {
    const next = { ...jours };
    if (entry === null) delete next[String(wd)];
    else next[String(wd)] = entry;
    onChange({ note, jours: next });
  };
  const setMode = (wd, mode) => {
    const cur = jours[String(wd)] || {};
    if (cur.mode === mode) { setDay(wd, null); return; }   // re-clic → efface (non renseigné)
    if (mode === "creneau") setDay(wd, { mode, debut: cur.debut || "09:00", fin: cur.fin || "18:00" });
    else setDay(wd, { mode });
  };
  const setTime = (wd, key, val) => {
    const cur = jours[String(wd)] || { mode: "creneau", debut: "09:00", fin: "18:00" };
    setDay(wd, { ...cur, mode: "creneau", [key]: val });
  };

  return (
    <div className="space-y-2" data-testid="dispo-editor">
      {WEEKDAYS_FR.map((lbl, wd) => {
        const entry = jours[String(wd)] || null;
        const mode = entry?.mode || "";
        return (
          <div key={wd}
            className="flex flex-wrap items-center gap-2 rounded-lg border border-[var(--border-soft)] bg-white px-2.5 py-1.5"
            data-testid={`dispo-row-${wd}`}>
            <span className={`${compact ? "w-16" : "w-20"} shrink-0 text-xs font-semibold`}>{lbl}</span>
            <div className="flex items-center gap-1">
              {MODES.map((m) => {
                const active = mode === m.v;
                return (
                  <button key={m.v} type="button" onClick={() => setMode(wd, m.v)}
                    className={`inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold transition-colors ${active
                      ? (m.v === "indispo"
                        ? "bg-[rgba(214,69,69,0.15)] text-[#9B2226]"
                        : m.v === "journee"
                          ? "bg-[rgba(31,122,68,0.14)] text-[#0F5A2F]"
                          : "bg-[rgba(47,111,237,0.14)] text-[#1D4ED8]")
                      : "text-muted-ink hover:bg-[var(--surface-2)]"}`}
                    data-testid={`dispo-mode-${wd}-${m.v}`}>
                    <m.icon className="h-3 w-3" />{m.label}
                  </button>
                );
              })}
            </div>
            {mode === "creneau" && (
              <div className="flex items-center gap-1" data-testid={`dispo-times-${wd}`}>
                <Input type="time" value={entry?.debut || "09:00"} onChange={(e) => setTime(wd, "debut", e.target.value)}
                  className="h-8 w-[104px] bg-white" data-testid={`dispo-debut-${wd}`} />
                <span className="text-xs text-muted-ink">–</span>
                <Input type="time" value={entry?.fin || "18:00"} onChange={(e) => setTime(wd, "fin", e.target.value)}
                  className="h-8 w-[104px] bg-white" data-testid={`dispo-fin-${wd}`} />
              </div>
            )}
            {!mode && <span className="text-[11px] italic text-muted-ink">Non renseigné</span>}
          </div>
        );
      })}
      <Textarea value={note} onChange={(e) => onChange({ note: e.target.value.slice(0, 500), jours })}
        placeholder="Note libre (ex. « Indispo le mercredi après-midi », contraintes particulières…)"
        className="min-h-[56px] resize-none bg-white text-sm" data-testid="dispo-note" />
    </div>
  );
};
